import { render, staticRenderFns } from "./UserConfigurationManagement.vue?vue&type=template&id=52d03274&scoped=true&"
import script from "./UserConfigurationManagement.vue?vue&type=script&lang=js&"
export * from "./UserConfigurationManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserConfigurationManagement.vue?vue&type=style&index=0&id=52d03274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d03274",
  null
  
)

export default component.exports